<template>
  <div class="box">
    <div
      class="modal"
      :class="{ 'is-active': modal }"
    >
      <div class="modal-background" />
      <div class="modal-content">
        <div class="box is-centered">
          <div class="field">
            <div class="label">
              ¿Para cancelar un pago es necesario generar su reemplazo, deseas continuar?
            </div>
            <div class="control is-centered">
              <div class="field is-grouped">
                <p class="control">
                  <a
                    class="button is-success"
                    :class="{ 'is-loading': isLoading }"
                    :disabled="isLoading"
                    @click="cancelById"
                  >
                    <span class="icon is-smal">
                      <i class="material-icons">
                        check
                      </i>
                    </span>
                    <span>
                      Sí
                    </span>
                  </a>
                </p>
                <p class="control">
                  <a
                    class="button is-danger"
                    :class="{ 'is-loading': isLoading }"
                    :disabled="isLoading"
                    @click="onCloseModal"
                  >
                    <span class="icon is-smal">
                      <i class="material-icons">
                        clear
                      </i>
                    </span>
                    <span>
                      No
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="onCloseModal"
      />
    </div>
    <h1 class="title is-4 has-text-primary">
      Complementos de Pago
    </h1>
    <AppPagination
      class="is-centered"
      :current-page="currentPage"
      :buttons-max="buttonsMax"
      :pages-total="totalPages"
      @change="goToPage"
    />
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>Folio</th>
          <th>Fecha</th>
          <th>RFC Receptor</th>
          <th>Razón social Cliente</th>
          <th>Total</th>
          <th>Tipo</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr v-if="isLoading">
          <td
            colspan="8"
            class="is-loading"
          >
            <a class="button is-loading is-fullwidth">
              Cargando..
            </a>
          </td>
        </tr>
        <template v-else>
          <tr
            v-if="invoices.length === 0"
          >
            <td
              class="empty"
              colspan="7"
            >
              Sin datos
            </td>
          </tr>
          <tr
            v-for="(invoice, index) in invoices"
            v-else
            :key="index"
          >
            <td>
              {{ invoice.voucherSeries }}
              -
              {{ invoice.voucherConsecutive }}
            </td>
            <td>{{ invoice.voucherDate | toHumanDate }}</td>
            <td>{{ invoice.receiverRfc }}</td>
            <td>{{ invoice.receiverName }}</td>
            <td>{{ totalPayments(invoice.complement.payments) }}</td>
            <td>{{ voucherTypeLabel(invoice.voucherType) }}</td>
            <td>
              <div class="actions is-left">
                <AppRadialMenu
                  :size="36"
                  :item-size="48"
                  :radius="80"
                  :angle-restriction="180"
                  :rotate="270"
                >
                  <AppRadialMenuItem
                    class="tooltip is-tooltip-primary has-background-primary has-text-white"
                    data-tooltip="Detalle de complemento"
                  >
                    <RouterLink
                      class="action-option"
                      :to="{ name: 'RepDetail', params: { uuid: invoice.id } }"
                    >
                      <BIcon
                        icon="eye"
                        class="action-option-icon"
                      />
                    </RouterLink>
                  </AppRadialMenuItem>
                  <AppRadialMenuItem
                    class="tooltip is-tooltip-success has-background-success has-text-white"
                    data-tooltip="Reenviar XML y PDF"
                  >
                    <a
                      class="action-option"
                      @click="sendEmail(invoice.id)"
                    >
                      <BIcon
                        icon="send"
                        class="action-option-icon"
                      />
                    </a>
                  </AppRadialMenuItem>
                  <AppRadialMenuItem
                    class="tooltip is-tooltip-info has-background-info has-text-white"
                    data-tooltip="Descargar XML"
                  >
                    <a
                      class="action-option"
                      @click="download('xml', invoice.id)"
                    >
                      <BIcon
                        icon="cloud-download"
                        class="action-option-icon"
                      />
                      <span class="close-label">
                        xml
                      </span>
                    </a>
                  </AppRadialMenuItem>
                  <AppRadialMenuItem
                    class="tooltip is-tooltip-info has-background-info has-text-white"
                    data-tooltip="Descargar PDF"
                  >
                    <a
                      class="action-option"
                      @click="download('pdf', invoice.id)"
                    >
                      <BIcon
                        icon="cloud-download"
                        class="action-option-icon"
                      />
                      <span class="close-label">
                        pdf
                      </span>
                    </a>
                  </AppRadialMenuItem>
                  <AppRadialMenuItem
                    class="tooltip is-tooltip-danger has-background-danger has-text-white"
                    data-tooltip="Cancelar Pago"
                  >
                    <a
                      class="action-option"
                      @click="cancelInvoice(invoice)"
                    >
                      <BIcon
                        icon="cancel"
                        class="action-option-icon"
                      />
                    </a>
                  </AppRadialMenuItem>
                </AppRadialMenu>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <AppPagination
      class="is-centered"
      :current-page="currentPage"
      :buttons-max="buttonsMax"
      :pages-total="totalPages"
      @change="goToPage"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import { voucherType as voucherTypeCatalog } from '@machete/common-catalogs';

export default {
  name: 'RepList',
  components: {
    AppPagination: () => import(/* webpackChunkName: "app-input-rfc" */ '@/components/AppPagination.vue'),
    AppRadialMenu: () => import(/* webpackChunkName: "app-radial-menu" */ '@/components/AppRadialMenu.vue'),
    AppRadialMenuItem: () => import(/* webpackChunkName: "app-radial-menu-item" */ '@/components/AppRadialMenuItem.vue'),
  },
  data() {
    return {
      isLoading: false,
      buttonsMax: 5,
      modal: false,
      invoiceToCanel: '',
      uuidDigitalTaxStamp: '',
    };
  },
  computed: {
    ...mapState({
      total: state => state.invoices.total,
      totalPages: state => state.invoices.totalPages,
    }),
    ...mapGetters({
      invoices: 'invoices/cleanInvoices',
    }),
    voucherTypeLabel() {
      return (key) => {
        const voucherType = voucherTypeCatalog.find(type => type.key === key);

        return voucherType.value;
      };
    },
    lastPage() {
      return Math.ceil(this.invoices.length / this.itemsPerPage);
    },
    currentPage() {
      return parseInt(this.$route.query.page, 10);
    },
    size() {
      return this.$route.query.size;
    },
  },
  watch: {
    buttonsMax(newValue, oldValue) {
      if (newValue % 2) {
        return;
      }
      if (newValue < oldValue) {
        this.buttonsMax = newValue - 1;
      }
      if (newValue > oldValue) {
        this.buttonsMax = newValue + 1;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.page) next();
    else {
      next({ name: to.name, query: { page: 1, size: 20 } });
    }
  },
  async beforeRouteUpdate(to, from, next) {
    const { page = 1, size = 20 } = to.query;

    await this.getAll({
      filter: 'rep',
      page,
      size,
    });

    next({ query: { page, size } });
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getAll({
      filter: 'rep',
      page: this.currentPage,
      size: this.size,
    });
    this.isLoading = false;
  },
  mounted() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal) {
        this.modal = false;
      }
    }, false);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', () => {});
  },
  methods: {
    ...mapActions({
      getAll: 'invoices/getAll',
      cancelByUuid: 'invoice/cancelByUuid',
    }),
    async download(type, uuid) {
      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'info',
        content: 'Descargando...',
        dateTime: now,
      });

      await this.$store.dispatch('invoice/getAsset', { type, uuid });

      this.$store.commit('ui/deleteNotification', now);
    },
    totalPayments(payments) {
      const sum = payments.reduce((accum, payment) => (
        accum + Number(payment.amount)
      ), 0);
      const string = sum.toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
      });

      return string;
    },
    async sendEmail(uuid) {
      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'info',
        content: 'Reenviando notificación...',
        dateTime: now,
      });

      await this.$store.dispatch('invoice/resendAssetsEmail', uuid);

      this.$store.commit('ui/deleteNotification', now);
      this.$store.dispatch('addTemporalNotification', {
        type: 'success',
        content: 'El correo con los archivos se reenvió correctamente.',
      });
    },
    goToPage(page) {
      const { size = 20 } = this.$route.query;

      const query = {
        page,
        size,
      };

      this.$router.push({ query });
    },
    checkLastPage() {
      if (this.currentPage < this.lastPage) {
        this.$router.push({ query: { page: this.lastPage } });
      }
    },
    cancelInvoice(invoice) {
      this.invoiceToCanel = invoice.id;
      this.uuidDigitalTaxStamp = invoice.complement.digitalTaxStamp.uuid;
      this.modal = true;
    },
    onCloseModal() {
      this.invoiceToCanel = '';
      this.modal = false;
    },
    async cancelById() {
      this.isLoading = true;
      try {
        await this.cancelByUuid(this.invoiceToCanel);
        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: 'El pago se canceló satisfactoriamente.',
        });
        this.$router.push({
          name: 'NewRep',
          query: { replace: this.uuidDigitalTaxStamp },
        });
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: `
            Ocurrió un error al tratar de cancelar la factura. <br>
            ${error.message}
          `,
        });
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.empty {
  vertical-align: center;
  text-align: center;
}

.action-option {
  display: flex!important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.close-label {
  margin-top: -8px;
}

</style>
